import { FORM_PATHS, openInModalOrPage } from '../../modals';
import { createFakeId } from '../../../reducers/util';

export const createVisitAction = (companyId, parentCommunicationId) => (dispatch, getState) => {
    dispatch(openInModalOrPage(FORM_PATHS.EditVisitActionModal, createFakeId(), {}, companyId, parentCommunicationId));
};
